<template>
    <van-popup
        v-model="visible"
        position="bottom"
        @close='onClose'
        :style="{ height: '70%' }"
    >
        <div class="protocol">
            <div class="head"><span @click="onClose"><van-icon name="close" /></span></div>
            <div class="content">
                <p><img src="../../../assets/img/b2b/server/01.png" /></p>
                <p><img src="../../../assets/img/b2b/server/02.png" /></p>
                <p><img src="../../../assets/img/b2b/server/03.png" /></p>
                <p><img src="../../../assets/img/b2b/server/04.png" /></p>
                <p><img src="../../../assets/img/b2b/server/05.png" /></p>
                <p><img src="../../../assets/img/b2b/server/06.png" /></p>
                <p><img src="../../../assets/img/b2b/server/07.png" /></p>
                <p><img src="../../../assets/img/b2b/server/08.png" /></p>
                <p><img src="../../../assets/img/b2b/server/09.png" /></p>
                <p><img src="../../../assets/img/b2b/server/10.png" /></p>
                <p><img src="../../../assets/img/b2b/server/11.png" /></p>
                <p><img src="../../../assets/img/b2b/server/12.png" /></p>
                <p><img src="../../../assets/img/b2b/server/13.png" /></p>
                <p><img src="../../../assets/img/b2b/server/14.png" /></p>
                <p><img src="../../../assets/img/b2b/server/15.png" /></p>
                <p><img src="../../../assets/img/b2b/server/16.png" /></p>
            </div>
        </div>
    </van-popup>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        visibleDialog: {
            get () {
                return this.visible
            },
            set () {
                this.$emit('update:visible')
            }
        }
    },
    methods: {
        onClose () {
            console.log('2222')
            this.$emit('update:visible')
        }
    }
}
</script>

<style lang="scss" scoped>
.protocol {
    position: relative;
    .head{
        height: 80px;
        line-height: 80px;
        font-size: 32px;
        text-align: center;
        position: fixed;
        left: 0;
        right: 0;
        background: #ffffff;
        span{
            position: absolute;
            right: 30px;
            top: 4px;
        }
    }
    .h40{
        height: 40px;
    }
    .content{
        // padding: 0 32px 32px;
        h3{
            font-size: 32px;
            text-align: center;
            line-height: 60px;
        }
        p{
            // line-height: 40px;
            // text-indent: 40px;
            &.textIndet{
                text-indent: inherit;
            }
        }
    }
}
/deep/ .van-popup__close-icon{
    font-size: 32px;
}
/deep/ .van-popup__close-icon--top-right{
    top: 24px;
}
</style>